import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d5ff8c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Add a Product", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Price($)", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "form-field"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Tax rate (%) ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Don't Charge Tax", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Quantity", -1))
const _hoisted_15 = { class: "form-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Subtotal", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "form-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Due Date", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-check" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "all_packages",
    type: "checkbox",
    class: "form-check-input",
    checked: ""
  }),
  /*#__PURE__*/_createElementVNode("label", {
    for: "all_packages",
    class: "form-check-label"
  }, " Automatically Charge Account On File ")
], -1))
const _hoisted_22 = { class: "form-field" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "col"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Adding Product ")
const _hoisted_26 = {
  key: 1,
  class: "col"
}

import { ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseModal from "@/components/BaseModal.vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
import moment from "moment";
import { TaxRateInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    required: true,
  },
  customerId: {
    type: Number,
    required: true,
  },
  productId: {
    type: Number,
    required: true,
  },
  productInventory: {
    type: Number,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  emits: ["modalClosed", "product"],
  setup(__props, { emit }) {

const props = __props

const formSubmitting = ref(false);
const status = ref("loading");
const errors = ref("");
const formErrors = ref<Record<string, string[]>>({});


const taxRates = ref();
const formFields = ref({
  action: "product",
  action_name: ref(""),
  customer_id: props.customerId,
  quantity: ref(1),
  unit_price: ref(1.0),
  billable_id: props.productId,
  billable_type: ref("Product"),
  description: ref(""),
  tax_rate_id: ref(null),
  due_on: moment().format("YYYY-MM-DD"),
  item_subtotal: ref(1.0),
});
function subtotal() {
  let price = formFields.value.unit_price;
  if (formFields.value.quantity) {
    price = price * formFields.value.quantity;
  }
  if (formFields.value.unit_price && formFields.value.tax_rate_id) {
    let percent = taxRates.value.filter(
      (item: TaxRateInterface) => item.id == formFields.value.tax_rate_id
    )[0].value_as_percentage;
    let tax = (Number(percent) / 100) * price;
    return tax + price;
  }
  return price;
}
async function getTaxRates() {
  formFields.value.action_name = props.name;
  errors.value = "";
  const response = await api({
    url: `tax_rates/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    taxRates.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "loaded";
}
async function submitForm() {
  formFields.value.item_subtotal = subtotal();
  emit("product", formFields.value);
  emit("modalClosed");
}

getTaxRates();

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_TransitionSlide = _resolveComponent("TransitionSlide")!

  return (_openBlock(), _createBlock(BaseModal, {
    ref: "modalRef",
    onModalClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('modalClosed')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : (status.value === 'loaded')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_TransitionSlide, { mode: "out-in" }, {
                default: _withCtx(() => [
                  (formErrors.value.non_field_errors !== undefined)
                    ? (_openBlock(), _createBlock(_component_BaseAlert, {
                        key: 0,
                        variant: "danger",
                        class: "js-form-error",
                        dismissible: "",
                        onDismissed: _cache[0] || (_cache[0] = ($event: any) => (formErrors.value = {}))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("form", {
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.action_name) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.action_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.unit_price) = $event)),
                    type: "decimal",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.unit_price]
                  ])
                ]),
                (taxRates.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.tax_rate_id) = $event)),
                        class: "form-select"
                      }, [
                        _hoisted_11,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRates.value, (tax) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: tax.id + 'tax',
                            value: tax.id
                          }, _toDisplayString(tax.value_as_percentage), 9, _hoisted_12))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, formFields.value.tax_rate_id]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.quantity) = $event)),
                    type: "number"
                  }, null, 512), [
                    [_vModelText, formFields.value.quantity]
                  ]),
                  _createElementVNode("small", null, " Remaining Inventory: " + _toDisplayString(__props.productInventory), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("input", {
                    type: "decimal",
                    value: subtotal().toFixed(2),
                    disabled: ""
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.description) = $event))
                  }, null, 512), [
                    [_vModelText, formFields.value.description]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.due_on) = $event)),
                    type: "date",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.due_on]
                  ])
                ]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    disabled: formSubmitting.value,
                    type: "submit",
                    class: "btn btn-text"
                  }, [
                    (formSubmitting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode(BaseSpinner)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_26, "Add Product"))
                  ], 8, _hoisted_23)
                ])
              ], 40, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})